(function(_window) {
  "use strict";

  if (typeof module === "object" && module && module.exports) {
    module.exports = _window.btoa;
  }
})(window);
